import { createSelector } from '@reduxjs/toolkit';
import { stateName } from './constants';

const localState = state => state[stateName];

export const getPhotos = state => localState(state).photos.byId;
export const getPhoto = (state, id) => getPhotos(state)[id];
export const getPhotoIds = state => localState(state).photos.ids;
export const getUiState = state => localState(state).uiState;
export const getPhotosCount = state => {
  return state.mediaUpload.photos.ids.length;
};
export const getCurrentImage = state => {
  const {
    currentImageId
  } = localState(state);
  if (!currentImageId) return null;
  return getPhoto(state, currentImageId);
};
export const getPhotoTempIds = createSelector(getPhotos, getPhotoIds, (photos, ids) => {
  const tempUuids = ids.map(id => {
    var _photos$id;

    return (_photos$id = photos[id]) === null || _photos$id === void 0 ? void 0 : _photos$id.tempUuid;
  });
  const filteredTempUuids = tempUuids.filter(value => typeof value === 'string' && value); // TODO: use TS fix import "@total-typescript/ts-reset/filter-boolean";

  return filteredTempUuids.length ? filteredTempUuids : undefined;
});